import React from 'react'

const SvgComponent = props => (
  <svg width={65} height={66} {...props}>
    <defs>
      <linearGradient
        x1="7.569%"
        y1="110.903%"
        x2="78.899%"
        y2="7.982%"
        id="docker__prefix__a"
      >
        <stop stopColor="#FAC9E3" stopOpacity={0.4} offset="0%" />
        <stop stopColor="#E3486A" offset="100%" />
      </linearGradient>
      <linearGradient
        x1="-12.039%"
        y1="1.214%"
        x2="155.653%"
        y2="90.79%"
        id="docker__prefix__b"
      >
        <stop stopColor="#FBA4B5" offset="0%" />
        <stop stopColor="#E3486A" offset="100%" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <ellipse
        fill="url(#docker__prefix__a)"
        opacity={0.166}
        cx={32.132}
        cy={32.675}
        rx={32.132}
        ry={32.675}
      />
      <path
        d="M10.466 33.982h43.73C53.569 45.7 44.019 55.004 32.33 55.004c-11.69 0-21.239-9.305-21.865-21.022z"
        fill="url(#docker__prefix__b)"
      />
      <path
        d="M12.596 41.75h19.352l-.014.263a23.022 23.022 0 0 1-4.01 11.852l-.096.14-.165-.038c-6.436-1.473-11.897-5.851-14.887-11.856l-.18-.361z"
        stroke="#E98699"
        strokeWidth={0.5}
        fill="#FEDFE5"
        opacity={0.5}
      />
      <path
        d="M53.798 35.195c.05 0 3.578-2.715 3.578-6.064s-3.578-6.064-3.578-6.064-3.578 2.715-3.578 6.064 3.528 6.064 3.578 6.064z"
        fill="url(#docker__prefix__b)"
      />
      <path
        d="M52.22 34.616c-.005-.05 2.29-3.89 5.577-4.24 3.286-.35 6.325 2.972 6.325 2.972s-2.29 3.89-5.577 4.24c-3.286.35-6.32-2.922-6.324-2.972z"
        fill="url(#docker__prefix__b)"
      />
      <g stroke="#E98699" strokeWidth={0.5}>
        <path
          fill="#F8F8F8"
          d="M15.486 26.955h6.258v6.777h-6.258zM21.847 26.955h6.258v6.777h-6.258zM28.207 26.955h6.258v6.777h-6.258zM34.568 26.955h6.258v6.777h-6.258zM40.93 26.955h6.257v6.777H40.93z"
        />
        <path
          d="M17.025 28.906v2.898M23.386 28.906v2.898M29.747 28.906v2.898M36.107 28.906v2.898M42.468 28.906v2.898M18.615 28.906v2.898M24.976 28.906v2.898M31.337 28.906v2.898M37.698 28.906v2.898M44.058 28.906v2.898M20.206 28.906v2.898M26.566 28.906v2.898M32.927 28.906v2.898M39.288 28.906v2.898M45.648 28.906v2.898"
          strokeLinecap="square"
        />
      </g>
      <g stroke="#E98699" strokeWidth={0.5}>
        <path
          fill="#F8F8F8"
          d="M21.847 20.083h6.258v6.777h-6.258zM28.208 20.083h6.258v6.777h-6.258zM34.568 20.083h6.258v6.777h-6.258z"
        />
        <path
          d="M23.386 22.034v2.897M29.747 22.034v2.897M36.107 22.034v2.897M24.976 22.034v2.897M31.337 22.034v2.897M37.698 22.034v2.897M26.566 22.034v2.897M32.927 22.034v2.897M39.288 22.034v2.897"
          strokeLinecap="square"
        />
      </g>
      <g stroke="#E98699" strokeWidth={0.5}>
        <path fill="#F8F8F8" d="M34.568 13.21h6.258v6.778h-6.258z" />
        <path
          d="M36.107 15.162v2.897M37.698 15.162v2.897M39.288 15.162v2.897"
          strokeLinecap="square"
        />
      </g>
    </g>
  </svg>
)

export default SvgComponent
